import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertThenFormat,
  formatDateTimezon,
  formattedLongDate,
} from "../../common-data/Converts";
import Loader from "../../ui/Loader";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { delete_incentive_slab } from "../../../data/ApiEndpoints";
import TrainerIncentivesMobile from "./rainer-incentives/TrainerIncentivesMobile";

const IncentiveCatTabs = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  selectedTab,
  handleTabSelect,
  callFunction,
  userInfoData,
  onClickAddBtn,
  isAdmin,
}) => {
  const dispatch = useDispatch();
  const {
    slabLoading,
    ptIncentivesSlabs,
    ptTrainerIncentivesLoading,
    ptTrainerIncentives,
    ptTrainerIncentivesError,
  } = useSelector((state) => state.incentives);

  const iniAllDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniAllDatas);

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_incentive_slab,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      ptTrainerIncentives?.status &&
      ptTrainerIncentives?.data?.length > 0 &&
      !ptTrainerIncentivesLoading &&
      !ptTrainerIncentivesError
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: ptTrainerIncentives.data,
        pagination:
          ptTrainerIncentives?.pagination?.length > 0
            ? ptTrainerIncentives.pagination
            : [],
      }));
    } else {
      setAllDatas(iniAllDatas);
    }
  }, [
    ptTrainerIncentives,
    ptTrainerIncentivesLoading,
    ptTrainerIncentivesError,
  ]);

  const trainersTbColumns = [
    isAdmin && {
      dataField: "trainer_id",
      text: "trainer detail",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.name || "NA"}
          <br />
          <small className="lowercase">
            {row?.trainer_mobile || ""}
            <br />
            {row?.trainer_email || ""}
          </small>
        </span>
      ),
    },
    isAdmin && {
      dataField: "gym_id",
      text: "gym name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "monthly_salary",
      text: "monthly salary",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.monthly_salary || 0)}
          </span>
        );
      },
    },
    {
      dataField: "total_incentive",
      text: "total incentives",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.total_incentive || 0)}
          </span>
        );
      },
    },
    {
      dataField: "total_earned_salary",
      text: "total earned",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.total_earned_salary || 0)}
          </span>
        );
      },
    },
    {
      dataField: "applicable_sub_count",
      text: "applicable subscriptions",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${
              Number(row?.applicable_sub_count || 0) ? "link" : ""
            }`}
            onClick={() =>
              Number(row?.applicable_sub_count || 0) &&
              onClickAddBtn("applicable-subscriptions", row)
            }
          >
            {row?.applicable_sub_count || 0}
          </span>
        );
      },
    },
    {
      dataField: "next_incentive_date",
      text: "Next incentive date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.next_incentive_date
              ? formatDateTimezon(row.next_incentive_date)
              : "-"}
          </span>
        );
      },
    },
  ];

  const slabsTbColumns = [
    {
      dataField: "min_amount",
      text: "Slab amount range",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              // display: "block",
              // minWidth: "100px",
              padding: "15px",
              background: "#FEEBCA",
              color: "#000",
              borderRadius: "4px",
            }}
          >
            ₹{convertThenFormat(row?.min_amount || 0)} - ₹
            {convertThenFormat(row?.max_amount || 0)}
          </span>
        );
      },
    },
    {
      dataField: "percentage",
      text: "Incentive percentage",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            style={{
              // display: "block",
              // minWidth: "50px",
              padding: "15px",
              background: "#D4D3EE",
              color: "#000",
              borderRadius: "4px",
            }}
          >
            {row?.percentage || 0}%
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={
              () => onClickAddBtn("edit-slab", row)
              // setModValues((prevs) => ({
              //   ...prevs,
              //   isModOpen: true,
              //   rowData: row,
              //   cardName: "edit-slab",
              // }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {slabLoading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16"
              >
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
            )}
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {!isAdmin ? (
        <>
          <div
            className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile"
            style={{
              marginTop: "20px",
            }}
          >
            {slabLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={allDatas.allData}
                tableColumns={trainersTbColumns}
                tablePagination={allDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            )}
          </div>

          <div className="lead-logs-card-container only-mobile">
            <TrainerIncentivesMobile
              tableData={allDatas.allData}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              onClickAddBtn={onClickAddBtn}
            />
          </div>
        </>
      ) : (
        <div className="fullWidthFlexCenter tabsContainer flexStart bgTransParent mb100">
          <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
            <TabList>
              <Tab>Trainer</Tab>
              <Tab>Slabs</Tab>
            </TabList>

            <TabPanel>
              <div
                className="fullWidthFlexCenter overflowAuto separatedTable no-border-table"
                style={{
                  marginTop: "20px",
                }}
              >
                {slabLoading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={allDatas.allData}
                    tableColumns={trainersTbColumns}
                    tablePagination={allDatas.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                )}
              </div>
            </TabPanel>
            <TabPanel>
              <div
                className="fullWidthFlexCenter overflowAuto separatedTable no-border-table"
                style={{
                  marginTop: "20px",
                }}
              >
                {slabLoading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={
                      Array.isArray(ptIncentivesSlabs?.data) &&
                      ptIncentivesSlabs?.data.length > 0
                        ? ptIncentivesSlabs.data
                        : []
                    }
                    tableColumns={slabsTbColumns}
                    tablePagination={
                      Array.isArray(ptIncentivesSlabs?.pagination) &&
                      ptIncentivesSlabs?.pagination.length > 0
                        ? ptIncentivesSlabs?.pagination
                        : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                )}
              </div>
            </TabPanel>
          </Tabs>
        </div>
      )}
    </>
  );
};

export default IncentiveCatTabs;
